import {
  Button,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@oniratec/onira-react-ui';
import { CheckCheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils/cn';
import { InAppNotification } from '@/modules/notifications/types';
import { NotificationItem } from './NotificationItem';

type NotificationsDropdownContentProps = {
  notifications: InAppNotification[];
  loading: boolean;
  markingAll: boolean;
  unreadInListCount: number;
  dropdownAlign: 'start' | 'end';
  dropdownSide: 'top' | 'bottom';
  onNotificationClick: (notification: InAppNotification) => void;
  onMarkAllAsRead: () => void;
};

export const NotificationsDropdownContent = ({
  notifications,
  loading,
  markingAll,
  unreadInListCount,
  dropdownAlign,
  dropdownSide,
  onNotificationClick,
  onMarkAllAsRead,
}: NotificationsDropdownContentProps) => (
  <DropdownMenuContent
    className="w-96 p-0"
    align={dropdownAlign}
    side={dropdownSide}
    sideOffset={8}
  >
    <div className="flex items-center justify-between px-3 py-2">
      <DropdownMenuLabel className="p-0 text-sm font-semibold">Notificaciones</DropdownMenuLabel>

      <Button
        variant="secondary"
        size="sm"
        onClick={() => {
          onMarkAllAsRead();
        }}
        loading={markingAll}
        disabled={unreadInListCount === 0}
        className={cn(
          'h-8 border border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-50',
          unreadInListCount === 0 && 'cursor-not-allowed border-slate-200 text-slate-400',
        )}
      >
        <div className="flex flex-row">
          <CheckCheckIcon className="mr-1 h-4 w-4" />
          Marcar leidas {unreadInListCount > 0 ? `(${unreadInListCount})` : ''}
        </div>
      </Button>
    </div>

    <DropdownMenuSeparator className="my-0" />

    <div className="max-h-[420px] overflow-y-auto">
      {loading ? (
        <div className="p-3 text-sm text-slate-500">Cargando notificaciones...</div>
      ) : notifications.length === 0 ? (
        <div className="p-3 text-sm text-slate-500">No tienes notificaciones.</div>
      ) : (
        notifications.map(notification => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClick={onNotificationClick}
          />
        ))
      )}
    </div>
  </DropdownMenuContent>
);
